import { AIRTestSettingsPanel } from '@frontend/ai-receptionist-sales-demo';

/**
 * ## SETTINGS GLOBAL PANEL REGISTRATION
 *
 * This file is used to register global panels that can be opened from anywhere in the app.
 * Simply export your global panel component here and it will be registered automatically.
 */

export const AiReceptionistTestGlobalPanel = AIRTestSettingsPanel;
